import axios from "axios";

// configure base url
const instance = axios.create({
    baseURL: "/",
    headers: { Accept: "application/json" },
});

instance.interceptors.request.use((config) => {
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) {
        config.headers["X-CSRF-TOKEN"] = token.getAttribute("content");
    }
    return config;
});
instance.interceptors.response.use(
    (response) => {
        replaceCsrfToken(response);
        return response;
    },
    (error) => {
        replaceCsrfToken(error.response);
        if (error.response && 401 === error.response.status && !window.location.pathname.startsWith("/login")) {
            window.location = "/login";
        }
        return Promise.reject(error);
    }
);

function replaceCsrfToken(response) {
    if (response && response.headers && response.headers["x-csrf-token"]) {
        const token = document.querySelector('meta[name="csrf-token"]');
        if (token) {
            token.setAttribute("content", response.headers["x-csrf-token"]);
        }
    }
}

export default instance;
